import request from '@/api/request';

const apiPrefix = '/bwp/globalComponent/singleSelectUsers';

const apiRoute = {
    userInfo : apiPrefix + '/userInfo'
}

const userInfo = (data)=> {
    return request({
        url: apiRoute.userInfo,
        method: 'post',
        data
    })
}

export default {
    userInfo
}